import Vue from 'vue';
import { library } from '@fortawesome/fontawesome-svg-core'
import { faMinus, faPlus, faPen, faEdit, faUserPlus, faUserAlt, faBuilding } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faMinus)
library.add(faPlus)
library.add(faPen)
library.add(faEdit)
library.add(faUserPlus)
library.add(faUserAlt)
library.add(faBuilding)

Vue.component('font-awesome-icon', FontAwesomeIcon)